// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2xNfz","options":"AnswerScale_options__2Y5If","selected":"AnswerScale_selected__5cO54"};